import script from "./FundingAnnualGoalsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FundingAnnualGoalsView.vue?vue&type=script&setup=true&lang=js"

import "./FundingAnnualGoalsView.vue?vue&type=style&index=0&id=be7063c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be7063c0"]])

export default __exports__